import dayjs from "dayjs";

export const messages: any[] = [
  {
    role: "cs",
    message:
      "No problem was matched. Please contact us. No problem was matched. Please contact us.",
    time: dayjs().valueOf(),
  },
  {
    role: "user",
    message: "No problem was matched. Please contact us.",
    time: dayjs().valueOf(),
  },
];

//角色类型， assistant表示AI，cs表示人工客服，user表示用户
export const roleType = {
  assistant: "assistant",
  cs: "cs",
  user: "user",
};

export const isHTML = (str: string) => /<[a-z][\s\S]*>/i.test(str);
